









import Vue from "vue";
import { gameStore } from "../store/game/store";
import { Client } from "@/client";
import { Action } from "@/store/game";
import _ from "lodash";
export default Vue.extend({
  computed: {
    visible() {
      return gameStore.state.ui.showConfirmTakeGlassDlg;
    },
    player() {
      return _.find(
        gameStore.state.players,
        p => p.id == gameStore.state.ui.glassPlayerId
      )?.name;
    }
  },
  methods: {
    dismiss() {
      gameStore.commitToggleConfirmTakeGlassDlg({ show: false });
    },
    getPlayerGlass() {
      Client.getInstance().send({
        action: Action.getPlayerGlass,
        glassPlayerId: gameStore.state.ui.glassPlayerId
      });
      this.dismiss();
    }
  }
});
